import Home from '../components/ExampleComponent';
import Login from '../components/LoginComponent';
import SqlLes from '../components/SqlLesComponent';
import AllStudents from '../components/AllStudentsComponent';


import {store} from './store.js'
export const routes = [
    { path: '/', component: SqlLes },
    { path: '/dashboard', component: AllStudents },
    { path: '/login', component: Login, name: 'Login',},
    {path: '/auth/:provider/callback',
        component: {
        template: '<div class="auth-component"></div>'
        }
    }
    ,
    { path: '/sql_les', component: SqlLes},
];
